import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=da02a94c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=da02a94c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da02a94c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da02a94c')) {
      api.createRecord('da02a94c', component.options)
    } else {
      api.reload('da02a94c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=da02a94c&scoped=true&", function () {
      api.rerender('da02a94c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k3GS74xCZplR/JS/comp/PopupBox.vue"
export default component.exports